import React, { Suspense, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { getApi } from "../../../Services/apiService";
import Modal from 'react-modal';
import { getApi } from "../../Services/apiService";
import ImageSliderModal from "./imageSlider";
import ImagePreview from "./imagePreview";
import InterstedModal from "./InterstedUser";
// import ReviewModal from "./reviewDetail";

// import "bootstrap/dist/css/bootstrap.min.css";
// import ImageSliderModal from "./imageSlider";
// import ImagePreview from "./imagePreview";

const EventDetail = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [eventDetails, setEventDetails] = useState(null);
  // const [interstedUser, setInterstedUser] = useState(null);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [imageFullOpen, setImageFullOpen] = useState(false);
  const [interstedUser, setInterstedUser] = useState(null);
  // const formatDate = (timestamp) => {
  //   const date = new Date(timestamp);
  //   return date.toISOString().split("T")[0];
  // };

    

  const formatDate = (timestamp) => {
    if (!timestamp) return 'NA';

    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.toLocaleString('en-GB', { month: 'long' });
    const year = date.getFullYear();

    const getOrdinalSuffix = (day) => {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    return `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
  };

  // const averageRating = (
  //   eventDetails?.Reviews?.reduce((sum, review) => sum + review.rating, 0) /
  //     eventDetails?.Reviews.length || 0
  // ).toFixed(1);

  const formatWebsiteUrl = (url) => {
    if (!url) return '';

    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return `http://${url}`;
    }

    return url;
  };

  const priceRangeMapping = {
    1: '$',
    2: '$$',
    3: '$$$',
    4: '$$$$',
    5: '$$$$$'
  };

  const openIntersterUserModal = () => {
    if (eventDetails?.EventAttendees?.length > 0) {
      setInterstedUser(eventDetails.EventAttendees); // Set attendees instead of reviews
      setIsUserModalOpen(true);
    }
  };
  const handleImageClick = (index) => {
    setSelectedIndex(index);
    setIsSliderOpen(true);
  };

  const fetchEventDetails = async () => {
    setLoading(true);

    try {
      const endpoint = `admin/events-details?event_id=${id}`;
      const response = await getApi(endpoint);
console.log("response", eventDetails);

      if (response && response.status === 200) {
        setEventDetails(response.data);
      } else {
        throw new Error("Failed to fetch venues.");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const closeSlider = () => {
    setIsSliderOpen(false);
  };

  // const openIntersterUserModal = () => {
  //   if (eventDetails?.Reviews?.length > 0) {
  //     setInterstedUser(eventDetails.Reviews);
  //     setIsUserModalOpen(true);
  //   }
  // };

  const closeInterstedUserModal = () => {
    setIsUserModalOpen(false);
    setInterstedUser(null);
  };

  const closeImageFull = () => {
    setImageFullOpen(false);
  };


  

  useEffect(() => {
    fetchEventDetails();
  }, []);




  
  // Helper function to format the rating with half and full stars using images
  const formatRating = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const totalStars = 5;
    const stars = [];
  
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <img
          key={`full-${i}`}
          src= {window.getPublicUrl("assets/images/full-star.png")}
          alt="Full Star"
          className="star-icon"
        />
      );
    }
  
    if (hasHalfStar) {
      stars.push(
        <img
          key="half"
          src= {window.getPublicUrl("assets/images/half-star.png")}
          alt="Half Star"
          className="star-icon"
        />
      );
    }
  
    for (let i = fullStars + (hasHalfStar ? 1 : 0); i < totalStars; i++) {
      stars.push(
        <img
          key={`empty-${i}`}
          src="/assets/images/empty-star.svg"
          alt="Empty Star"
          className="star-icon"
        />
      );
    }
  
    return stars;
  };
  

  return (
    <div className="RightSideDiv banner-view">
      <div className="car-care-tips">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="row">
              <div className="col-md-12"></div>
              <div className="col-md-6">
                <div className="left">
                  <div className="lef-banner">
                    <img
                      src={eventDetails?.EventImages[0]?.url}
                      alt={eventDetails?.name}
                      className=""
                      height={200}
                      width={200}
                      onClick={() => setImageFullOpen(true)}
                    />
                    {imageFullOpen && (
                      <div
                        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80"
                        onClick={() => setImageFullOpen()}
                      >
                        <img
                          src={eventDetails?.EventImages[0]?.url}
                          alt={eventDetails?.name}
                          className="max-w-full max-h-full"
                        />
                      </div>
                    )}
                  </div>

                  {/* <div className="image-gallery">
                    <h1>Photos</h1>
                    {eventDetails?.Category_Images?.length &&
                      eventDetails?.Category_Images.map((img, index) => (
                        <img
                          key={img.id}
                          src={img.url}
                          alt="eventDetails"
                          className="thumbnail"
                          onClick={() => handleImageClick(index)}
                        />
                      ))}
                  </div> */}
                            <div className="image-gallery">
                    <h1>Photos</h1>
                    {eventDetails?.EventImages?.length &&
                      eventDetails?.EventImages.map((img, index) => (
                        <img
                          key={img.id}
                          src={img.url}
                          alt="eventDetails"
                          className="thumbnail"
                          onClick={() => handleImageClick(index)}
                        />
                      ))}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="view-deatils-data">
                  <h3 className="heading">{eventDetails?.name}</h3>
                  <ul>
                    <li>
                      <h5>Special Offer:</h5> <span>{eventDetails?.special_offer||'N/A'}</span>
                    </li>
                    <li>
                      <h5>Date:</h5><span>{formatDate(eventDetails?.date) || 'NA'}</span></li>
                    {/* <li>
                      <h5>Start Time:<span>{format(eventDetails?.start_time) || 'NA'}</span></h5>
                    </li>
                    <li>
                      <h5>end Time:<span>{formatTime(eventDetails?.end_time) || 'NA'}</span></h5>
                    </li> */}
                    <li>
                      <h5>Location:</h5> <span>{eventDetails?.category_location}</span>
                    </li>
                    <li>
                      <h5>Entry Booking Detail:</h5>
                      <span>{eventDetails?.entry_booking_detail}</span>
                    </li>
                    <li>
                      <h5>Category Name:</h5>
                      <span>{eventDetails?.category_name}</span>
                    </li>
                    <li>
                      <h5>Price:</h5>
                      <span>{eventDetails?.price ||'N/A'}</span>
                    </li>
                    <li>
                      <h5>Description:</h5>
                      <span>{eventDetails?.description}</span>
                    </li>
                    <li>
                      <h5>Booking Url:</h5>
                      <span>
  <a href={eventDetails?.booking_url} target="_blank" rel="noopener noreferrer">
    {eventDetails?.booking_url}
  </a>
</span>
                    </li>
                  </ul>
                </div>
                {eventDetails?.EventAttendees?.length > 0 && (
  <div>
    {/* <h4 className="review-heading" onClick={openIntersterUserModal}>
      Interested User
    </h4> */}

<li className="reviewli">
  <div className="review-main">
    <h1>Interested User</h1>
    <div className="users-profile">
      {eventDetails?.EventAttendees.slice(0, 3).map((attendee) => (
        <div key={attendee?.User?.id} className="mb-3">
          <span>
            <img
              src={attendee?.User?.image || window.getPublicUrl("/assets/images/dummy-profile.jpg")}
              alt="eventDetails"
            />
          </span>
          <div className="review-name-main">
            <p className="review-name">{attendee?.User?.name || "Unknown"}</p>
            <p className="sur-name">{attendee?.User?.user_name || "Unknown"}</p>
          </div>
        </div>
      ))}
    </div>

    {/* Show "All Users" button only if there are more than three attendees */}
    {eventDetails?.EventAttendees?.length > 2 && (
      <div className="d-flex justify-content-end mt-3">
        <button className="read-more" onClick={openIntersterUserModal}>
          All Users
        </button>
      </div>
    )}
  </div>
</li>

  </div>
)}


           
              </div>
            </div>
          </>
        )}

      </div>

      <Suspense fallback={<div>Loading...</div>}>
        <Modal
          isOpen={isUserModalOpen}
           className={'interseted-users'}
          onRequestClose={closeInterstedUserModal}
          contentLabel="Review Modal"
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName="modal-overlay review-modal"
          portalClassName="review-modal-xyz"
        >
          <InterstedModal isOpen={isUserModalOpen} onClose={closeInterstedUserModal} Users={interstedUser} />
        </Modal>
      </Suspense>




      <Suspense fallback={<div>Loading...</div>}>
        <Modal
          isOpen={imageFullOpen}
          onRequestClose={closeImageFull}
          contentLabel="Image Slider Modal"
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName="modal-overlay review-modal"
          portalClassName="review-modal-portal"
        >
          <ImagePreview
            isOpen={imageFullOpen}
            onClose={closeImageFull}
            images={eventDetails?.EventImages[0]?.url}
          />
        </Modal>
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <Modal
          isOpen={isSliderOpen}
          onRequestClose={closeSlider}
          contentLabel="Image Slider Modal"
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName="modal-overlay review-modal"
          portalClassName="review-modal-portal"
        >
          <ImageSliderModal
            isOpen={isSliderOpen}
            onClose={closeSlider}
            selectedIndex={selectedIndex}
            images={eventDetails?.EventImages}
          />
        </Modal>
      </Suspense>
    
    </div>
  );
};

export default EventDetail;